import {
  FETCH_PARTIESLIST_REQUEST,
  FETCH_PARTIESLIST_SUCCESS,
  FETCH_PARTIESLIST_FAILURE,
} from "./reletedPartiesListTypes";
import api from "../../utils/Api";
import axios from 'axios';

// Headers

export const fetchPartiesListRequest = () => {
  return {
    type: FETCH_PARTIESLIST_REQUEST,
  };
};

export const fetchPartiesListSuccess = (partiesList) => {
  return {
    type: FETCH_PARTIESLIST_SUCCESS,
    payload: partiesList,
  };
};

export const fetchPartiesListFailure = (error) => {
  return {
    type: FETCH_PARTIESLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchPartiesList = (searchKey,sortBy,page, lk_related_party_role_id, isPatientList ) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "relatedparty?search_key="+searchKey+'&sort_by='+sortBy+"&page="+page;
  if(lk_related_party_role_id){
    url += "&lk_related_party_role_id="+lk_related_party_role_id;
  }
  if(isPatientList === 1 || isPatientList === 0){
    url+="&isPatientList="+ isPatientList;
  }
  return async (dispatch) => {
    dispatch(fetchPartiesListRequest);
    try {
      const response = await api.get(url, {
        headers: headers,
        cancelToken: new CancelToken(function executor(c) {
          cancelRequest = c;
      })
      });
      const partiesList = response.data.data;
      dispatch(fetchPartiesListSuccess(partiesList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchPartiesListFailure(errorMsg));
    }
  };
};
